<template>
  <div>
    <div style="display: flex; justify-content: space-between; padding: 10px; align-items: center;">
      <div style="display: flex; justify-content: space-between; align-items: center; padding-right: 10px">
        <el-input v-model="instId" clearable placeholder="货币ID"
                  @keyup.enter.native="getTradeConfigList()" @keyup="getTradeConfigList()">
        </el-input>
        <el-select v-model="trigger_mode" clearable default-first-option placeholder="策略类型"
                   @change="getTradeConfigList()">
          <el-option key="1" label="抄底策略A" :value="1"></el-option>
          <el-option key="2" label="抄底策略B" :value="2"></el-option>
          <el-option key="3" label="抄底策略C" :value="3"></el-option>
          <el-option key="4" label="超短线做多" :value="4"></el-option>
        </el-select>
        <!--        <el-button size="mini" slot="append" icon="el-icon-search" @click="getTradeConfigList()"></el-button>-->
      </div>
      <div style="width: 100px">
        <el-button size="mini" circle @click="getTradeConfigList()">
          <i class="el-icon-refresh-left"></i>
        </el-button>
        <el-button type="primary" size="mini" circle @click="tradeConfigSave()">
          <i class="el-icon-circle-plus-outline"></i>
        </el-button>
      </div>
    </div>
    <el-table
      style="width: 100%"
      :data="tableData"
      row-key="id"
      :expand-row-keys="expand_rows"
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" class="demo-table-expand">
            <el-form-item label="交易平台:">
              <span>{{ props.row.platform }}</span>
            </el-form-item>
            <el-form-item label="商品名称:">
              <span>{{ props.row.instId }}</span>
            </el-form-item>
            <!--            策略配置-->
            <el-table :data="props.row.strategy_list" :show-header="false" border style="width: 100%">
              <el-table-column type="expand" width="30">
                <template slot-scope="{row}">
                  <el-form label-position="left">
                    <div style="display: flex; padding: 0 10px; flex-flow: column;">
                      <span style="padding-bottom: 5px">策略：模式{{ row.trigger_mode }}</span>
                      <span style="padding-bottom: 5px">触发价格：{{ row.trigger_price }}U</span>
                      <span style="padding-bottom: 5px">K线粒度：{{ row.bar }}</span>
                      <span style="padding-bottom: 5px">K线数：{{ row.k_limit }}</span>
                      <span style="padding-bottom: 5px">下单金额：{{ row.order_amount }}U</span>
                      <span style="padding-bottom: 5px">触发跌幅：{{ row.trigger_rate }}%</span>
                      <span style="padding-bottom: 5px">止盈点数：{{ row.pTriggerPx_rate }}%</span>
                      <span style="padding-bottom: 5px">止损点数：{{ row.slTriggerPx_rate }}%</span>
                      <span style="padding-bottom: 5px">触发比率：{{ row.cur_bar_avg_rate_ratio }}</span>
                      <span style="padding-bottom: 5px">订单期限：{{ row.order_living_time / 60 }}分钟</span>
                    </div>
                  </el-form>
                </template>
              </el-table-column>
              <el-table-column label="货币" prop="trigger_mode" width="80px">
                <template slot-scope="{row}">
                  <div>
                    <div style="background: red; color: white; font-size: 10px; border-radius: 20%; width: fit-content; padding: 0px 3px;">
                      模式{{ row.trigger_mode }}
                    </div>
                    <div style="font-size: 12px">
                      K{{ '(' + row.bar + ')'}}
                    </div>
                    <!--                    <div style="font-size: 12px">-->
                    <!--                      K{{ '(' + row.bar + ' x ' + row.k_limit + ')'}}-->
                    <!--                    </div>-->
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="货币">
                <template slot-scope="{row}">
                  <div style="display: flex; font-size: 12px">
                    <div style="padding-right: 2px;">
                      <div>价</div>
                      <div>幅</div>
                    </div>
                    <div style="font-size: 11px;">
                      <div>{{ toNonExponential(row.trigger_price) }}</div>
                      <div>{{ row.trigger_rate+ '%' }}</div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="启用" width="50px">
                <template slot-scope="{row}">
                  <el-switch style="zoom:0.7;" :value="row.is_enable === 1" @change="triggerLevelEnable(row)"></el-switch>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="90px">
                <template slot-scope="{row}">
                  <el-button type="primary" size="mini" circle @click="triggerLevelSave(row.instId, props.row.platform, row)">
                    <i class="el-icon-edit-outline"></i>
                  </el-button>
                  <el-button type="danger" size="mini" circle @click="triggerLevelDel(row.id)">
                    <i class="el-icon-delete-solid"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column
        label="货币"
        prop="instId"
        :default-sort="{prop: 'instId', order: 'descending'}"
        sortable
      >
        <template slot-scope="props">
          <div style="display: flex; align-items: center">
            <div style="margin-left: -10px;">
              <img style="margin-right: 2px" width="12px" height="12px" :src="platformIcon(props.row.platform)">
            </div>
            <div>
              {{ coinName(props.row.instId) }}<span style="color: #07bd54; font-size: 12px; font-weight: bold; background: #dcdfe6;">{{ '(' + props.row.lever + 'x)' }}</span><span style="color: red; font-size: 20px" v-show="props.row.strategy_list.length > 0"> •</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="启用" width="48">
        <template slot-scope="{row}">
          <el-switch style="zoom: .8" :value="row.is_enable === 1" @change="tradeConfigEnable(row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="130">
        <template slot-scope="{row}">
          <el-button type="primary" size="mini" circle @click="triggerLevelSave(row.instId, row.platform)">
            <i class="el-icon-circle-plus"></i>
          </el-button>
          <el-button type="primary" size="mini" circle @click="tradeConfigSave(row)">
            <i class="el-icon-edit-outline"></i>
          </el-button>
          <el-button type="danger" size="mini" circle @click="tradeConfigDel(row.id)">
            <i class="el-icon-delete-solid"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <trade-config-save ref="tradeForm" @successfn="getTradeConfigList"></trade-config-save>
    <trigger-level ref="triggerLevel" @successfn="triggerStrategyCallback"></trigger-level>
  </div>
</template>

<script>
import api from '@/api/api'
import TradeConfigSave from '@/components/platformPairKlineConfig/TradeConfigSave.vue'
import TriggerLevel from '@/components/platformPairKlineConfig/TriggerLevel.vue'
import BigNumber from 'bignumber.js'
import { getPlatformIcon } from '@/utils/platformIcon'

export default {
  name: 'TradeConfigs',
  components: {
    TradeConfigSave,
    TriggerLevel
  },
  data () {
    return {
      value: true,
      instId: '',
      trigger_mode: '',
      tableData: [],
      expand_rows: []
    }
  },
  created () {
    this.getTradeConfigList()
  },
  methods: {
    coinName (instId) {
      return instId.replace('-USDT-SWAP', '')
    },
    platformIcon (platform) {
      return getPlatformIcon(platform)
    },
    bigDecimal (num) {
      return new BigNumber(num).toNumber()
    },
    toNonExponential (num) {
      num = Number(num)
      const m = num.toExponential().match(/\d(?:.(\d*))?e([+-]\d+)/)
      return num.toFixed(Math.max(0, (m[1] || '').length - m[2]))
    },
    triggerStrategyCallback (instId) {
      this.expand_rows = [instId]
      this.getTradeConfigList()
    },
    // 货币配置列表
    getTradeConfigList () {
      this.$loading({ body: true })
      api.tradeConfigList({ instId: this.instId, trigger_mode: this.trigger_mode }).then(res => {
        if (res.code === 0) {
          this.tableData = res?.data || []
        } else {
          this.$message.error('获取配置失败')
        }
      }).catch(res => {
        this.$message.error('获取配置失败')
      }).finally(_ => {
        this.$loading({}).close()
      })
    },
    // 货币配置启用或者禁用
    tradeConfigEnable (row) {
      let enable = 1 // 默认开启
      if (parseInt(row.is_enable) === 1) { // 当前是开启就修改为关闭
        enable = 0
      }
      api.tradeConfigEnable({ id: row.id, is_enable: enable }).then(res => {
        if (res.code === 0) {
          this.$message.success({
            message: '操作成功',
            customClass: 'phone-custom-message'
          })
        } else {
          this.$message.error({
            message: '获取配置失败',
            customClass: 'phone-custom-message'
          })
        }
      }).catch(res => {
        this.$message.error({
          message: '获取配置失败',
          customClass: 'phone-custom-message'
        })
      }).finally(() => {
        this.getTradeConfigList()
      })

      return enable
    },
    // 货币配置删除
    tradeConfigDel (id) {
      this.$confirm('删除后关联策略也将删除！', '确认删除？', {
        type: 'warning',
        customClass: 'mobile-message-box'
      })
        .then(_ => {
          api.tradeConfigDel({ id: id }).then(res => {
            if (res.code === 0) {
              this.$message.success({
                message: '操作成功',
                customClass: 'phone-custom-message'
              })
            } else {
              this.$message.error({
                message: '操作失败',
                customClass: 'phone-custom-message'
              })
            }
          }).catch(res => {
            this.$message.error({
              message: '操作失败',
              customClass: 'phone-custom-message'
            })
          }).finally(() => {
            this.getTradeConfigList()
          })
        })
        .catch(_ => {})
    },
    // 货币配置提交
    tradeConfigSave (item) {
      const editReport = this.$refs.tradeForm
      if (item) {
        editReport.show(item)
      } else {
        editReport.show()
      }
    },
    // --触发配置--
    // 触发配置提交
    triggerLevelSave (instId, platform, item) {
      const editTriggerLevel = this.$refs.triggerLevel
      if (item) {
        editTriggerLevel.show(instId, platform, item)
      } else {
        editTriggerLevel.show(instId, platform)
      }
    },
    // 触发配置删除
    triggerLevelDel (id) {
      this.$confirm('', '确认删除？', {
        type: 'warning',
        customClass: 'mobile-message-box'
      })
        .then(_ => {
          api.triggerLevelDel({ id: id }).then(res => {
            if (res.code === 0) {
              this.$message.success({
                message: '操作成功',
                customClass: 'phone-custom-message'
              })
            } else {
              this.$message.error({
                message: '操作失败',
                customClass: 'phone-custom-message'
              })
            }
          }).catch(res => {
            this.$message.error({
              message: '操作失败',
              customClass: 'phone-custom-message'
            })
          }).finally(() => {
            this.getTradeConfigList()
          })
        })
        .catch(_ => {})
    },
    // 触发配置启用或禁用
    triggerLevelEnable (row) {
      let enable = 1 // 默认开启
      if (parseInt(row.is_enable) === 1) { // 当前是开启就修改为关闭
        enable = 0
      }
      api.triggerLevelEnable({ id: row.id, is_enable: enable }).then(res => {
        if (res.code === 0) {
          this.$message.success({
            message: '操作成功',
            customClass: 'phone-custom-message'
          })
        } else {
          this.$message.error({
            message: '操作失败',
            customClass: 'phone-custom-message'
          })
        }
      }).catch(res => {
        this.$message.error({
          message: '操作失败',
          customClass: 'phone-custom-message'
        })
      }).finally(() => {
        this.getTradeConfigList()
      })
    }
  }
}
</script>

<style scoped>
.demo-table-expand {
  font-size: 0;
  padding: 0 5%;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
}
.el-switch {
  display: flex !important;
}
</style>
<style>
.mobile-message-box {
  width: 80% !important; /* 设置宽度为屏幕宽度的 80% */
  max-width: 300px; /* 最大宽度 */
}
.phone-custom-message {
  top: 30% !important; /* 垂直居中 */
  left: 50% !important; /* 水平居中 */
  transform: translate(-50%, -50%) !important; /* 偏移修正 */
  width: auto !important; /* 宽度自适应 */
  min-width: 200px; /* 最小宽度 */
  text-align: center; /* 文字居中 */
}
</style>
